export const changeNState = (e) => {
    return (dispatch) => {
        return dispatch({ type: 'CHANGE_NOTIFY_STATE', payload: e}) 
    }
}

export const changeNumberOfNotify = (falsOrTrue,Numbers) => {
    return (dispatch) => {
        dispatch({ type: 'NUMBER_NEW_NOTIFY', payload: Numbers}) 
        dispatch({ type: 'SHOW_NEW_NOTIFY', payload: falsOrTrue}) 
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/notificacoes.js